/* GRIPT premium cart drawer behaviour */
(function () {
  if (window.__griptCart) return;
  window.__griptCart = true;

  // One-tap add from cart upsells, then re-render the drawer in place.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gc-add]');
    if (!btn || btn.classList.contains('is-loading')) return;
    e.preventDefault();
    var label = btn.querySelector('span');
    btn.classList.add('is-loading');
    if (label) label.textContent = 'Adding';
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.dataset.gcAdd), quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status || !data.sections) throw new Error(data.description || 'Could not add');
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function') {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        if (label) label.textContent = 'Retry';
      });
  });

  // Staggered entrance each time the drawer opens.
  if (window.customElements) {
    customElements.whenDefined('cart-drawer').then(function () {
      var C = customElements.get('cart-drawer');
      var open = C.prototype.open;
      C.prototype.open = function () {
        var el = this;
        el.classList.add('gc-opening');
        clearTimeout(el._gcT);
        el._gcT = setTimeout(function () { el.classList.remove('gc-opening'); }, 1500);
        return open.apply(this, arguments);
      };
    });
  }
})();

/* "Added to cart" toast: fully hidden when off, and auto-dismisses after ~1.8s */
(function () {
  if (window.__griptToastFix) return;
  window.__griptToastFix = true;
  var HIDE_AFTER = 1800;
  var css = 'html .gp-toast{opacity:0;visibility:hidden;pointer-events:none;' +
    'transition:transform .6s cubic-bezier(.16,1,.3,1),opacity .3s ease,visibility 0s linear .6s}' +
    'html .gp-toast.is-on{opacity:1;visibility:visible;pointer-events:auto;' +
    'transition:transform .6s cubic-bezier(.16,1,.3,1),opacity .2s ease,visibility 0s}';
  var st = document.createElement('style');
  st.id = 'gript-toast-fix';
  st.textContent = css;
  document.head.appendChild(st);

  function watch(t) {
    if (t.__gtWatched) return;
    t.__gtWatched = true;
    var timer;
    function arm() {
      clearTimeout(timer);
      if (t.classList.contains('is-on')) {
        timer = setTimeout(function () { t.classList.remove('is-on'); }, HIDE_AFTER);
      }
    }
    new MutationObserver(arm).observe(t, { attributes: true, attributeFilter: ['class'] });
    var txt = t.querySelector('[data-gp-toast-text]');
    if (txt) new MutationObserver(arm).observe(txt, { childList: true, characterData: true, subtree: true });
    arm();
  }
  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-gp-toast]'), watch);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

// Kept for the cart page upsell snippets, which still call these.
function gcUpsellVariantChange(n, containerSel) {
  var c = document.querySelector(containerSel); if (!c) return;
  var vs = c.querySelector('#variant-selects-cart-upsell-' + n); var f = c.querySelector('.form'); if (!vs || !f) return;
  var idField = f.querySelector('input[name="id"]');
  var v = JSON.parse(vs.querySelector('script[type="application/json"]').textContent).find(function (variant) {
    for (var i = 0; i < variant.options.length; i++) { var s = document.querySelector('#Option-cart-upsell-' + n + '-' + i); if (s && s.value !== variant.options[i]) return false; }
    return true;
  });
  if (!v) return;
  idField.value = v.id;
  vs.setAttribute('data-product-id', v.id);
  if (v.featured_image && v.featured_image.src) { var img = c.querySelector('.cart-upsell__image__img'); if (img) img.src = v.featured_image.src; }
}
function primaryUpsellVariantChange() { gcUpsellVariantChange(1, '.cart-primary-upsell'); }
function secondaryUpsellVariantChange() { gcUpsellVariantChange(2, '.cart-secondary-upsell'); }